module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Kimberly Willis Holt\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("Kimberly Willis Holt")]), _vm._v(" is the author of the many award-winning novels for young adults and children, including "), _c('I', [_vm._v("The Water Seeker, My Louisiana Sky")]), _vm._v(", and "), _c('I', [_vm._v("When Zachary Beaver Came to Town")]), _vm._v(", winner of a National Book Award for Young People's Literature. She is also the author of the bestselling Piper Reed series of chapter books and several picture books. Holt was born in Pensacola, Florida, and has lived all over the world—from Paris to Norfolk to Guam to New Orleans. She now lives in Texas with her family.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/6gEKh8/images/9781627794435.jpg?1726274132180",
      "alt": "This image is the cover for the book Dear Hank Williams"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Dear Hank Williams\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("It's 1948 in Rippling Creek, Louisiana, and Tate P. Ellerbee's new teacher has just given her class an assignment—learning the art of letter-writing. Luckily, Tate has the perfect pen pal in mind: Hank Williams, a country music singer whose star has just begun to rise. Tate and her great-aunt and -uncle listen to him on the radio every Saturday night, and Tate just knows that she and Hank are kindred spirits."), _c('br'), _c('br'), _vm._v("Told entirely through Tate's hopeful letters, this beautifully drawn novel from National Book Award–winning author Kimberly Willis Holt gradually unfolds a story of family love, overcoming tragedy, and an insightful girl learning to find her voice."), _c('br'), _c('br'), _vm._v("This title has Common Core connections.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Henry Holt and Company\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0